<div class="overflow-hidden full-width-banner animation-long"
     [class.animation-fade-in]="!client.isCms && component.animation"
     [gsap]
     [gsapOff]="client.isCms || !component.animation"
     [scrollTrigger]="{
       start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true
    }">
    <href [link]="component.link">
        <div class="ratio-16-9 ratio-1-1-s overflow-hidden">
            @if (component.video_id && !component.image) {
            <shell />
            }
            @if (component.image) {
            <div class="fill z-1"
                 [gsap]="{ y: '20%' }"
                 [gsapOff]="client.isCms || !component.animation"
                 [scrollTrigger]="{ start: '0% top', end: '100% top', id: 'parallax' }">
                <img [dfImage]="component.image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="client.isS ? '1' : '16/9'"
                     [alt]="''"
                     fill>
            </div>
            }
            @if (component.video_id) {
            <local-vimeo-player class="rf z-2 bg-col-w"
                                [video-id]="component.video_id"
                                [autoplay-in-viewport]="true"
                                [controls]="false" />
            }
            <div class="fill z-3"
                 [gsap]="{ opacity: 0 }"
                 [gsapOff]="client.isCms || !component.animation"
                 [scrollTrigger]="{ id: 'opacity', start: '55% center', end: '80% center'}">
                @if (!(client.isS && component.text_box_below)) {
                <div class="pos-absolute z-3"
                     [style.top.%]="(component.top_position || 0)"
                     [style.left.%]="(component.left_position || 0)">
                    <ng-container *ngTemplateOutlet="tpl" />
                </div>
                }
            </div>
        </div>
        @if (client.isS && component.text_box_below) {
        <div class="w-12 m-t p-l p-r">
            <ng-container *ngTemplateOutlet="tpl" />
        </div>
        }
    </href>
</div>

<ng-template #tpl>
    <div [class]="component.text_align">
        <div [style.color]="component.text_color">
            <p [class]="component.heading ? 'o1 m-b-1' : ''"
               *iCms="'heading' of component; skipEmpty: true"></p>
            <h1 class="m-b-2"
                [class]="component.title_style || 'h1 p-t-2-s'"
                *iCms="'title' of component; skipEmpty: true"></h1>
        </div>
        @if (component.cta_text) {
        <a [class]="component.cta_style || 'button-3'"
           [routerLink]="component.link">
            <span class="button__body"
                  *iCms="'cta_text' of component"></span>
        </a>
        }
    </div>
</ng-template>